import type { Branding, FeaturesModel, FeaturesRepository } from "@trading/core";
import axios from "../axios";
import { AppError, BusinessError } from "../errorTypes";
import { isApiError, type ApiResponse } from "../types";

function normalizeFeatures(features: unknown): FeaturesModel["features"] {
  if (!features || typeof features !== "object" || Array.isArray(features))
    return {};

  return features as FeaturesModel["features"];
}

function normalizeBranding(branding: unknown): Branding | undefined {
  if (!branding || typeof branding !== "object" || Array.isArray(branding))
    return undefined;

  return branding as Branding;
}

export class FeatureRepositoryAxios implements FeaturesRepository {
  constructor(private apiClient = axios) {}

  async getFeatures(brand?: string): Promise<FeaturesModel> {
    const response = await this.apiClient.get<ApiResponse<FeaturesModel>>(
      "/features",
      {
        isAuthRequired: false,
        params: brand ? { brand } : undefined,
      },
    );
    if (response instanceof AppError) throw response;

    const envelope = response.data;
    if (!envelope.success) {
      throw new BusinessError(
        isApiError(envelope.error)
          ? envelope.error.message
          : "Failed to load features",
      );
    }

    return {
      branding: normalizeBranding(envelope.data?.branding),
      features: normalizeFeatures(envelope.data?.features),
    };
  }
}
